var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    staticClass: "feature-4",
    class: {
      more: _vm.moreOpened
    }
  }, [_c('div', {
    staticClass: "feature-header lead-1-large"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.feature.title)
    }
  })]), _c('div', {
    staticClass: "feature-content-wrapper"
  }, [_c('div', {
    staticClass: "feature-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.feature.image,
      "alt": ""
    }
  })]), _c('div', {
    ref: "text",
    staticClass: "feature-box-title paragraph-1",
    domProps: {
      "innerHTML": _vm._s(_vm.feature.subTitle)
    }
  }), _vm.feature.buttonLabel ? _c('div', {
    staticClass: "button-container"
  }, [_c('seu-button', {
    attrs: {
      "label": _vm.moreOpened ? _vm.feature.buttonLabelLess : _vm.feature.buttonLabel,
      "button-link": _vm.feature.buttonLink,
      "button-icon-after": _vm.rightArrow
    },
    on: {
      "click": _vm.toggleMore
    }
  })], 1) : _vm.overflow ? _c('div', {
    staticClass: "button-container"
  }, [_c('seu-button', {
    attrs: {
      "label": _vm.moreOpened ? _vm.$t('common.less') : _vm.$t('common.more'),
      "button-icon-after": _vm.rightArrow
    },
    on: {
      "click": _vm.toggleMore
    }
  })], 1) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }